import { InteropInterfaceContractParameter } from '@neo-one/node-core';
import { InvalidValueBufferError, UnsupportedStackItemSerdeError } from './errors';
import { StackItemBase } from './StackItemBase';
export class ObjectStackItem extends StackItemBase {
    constructor(value) {
        super();
        this.value = value;
    }
    asBoolean() {
        return this.value !== undefined;
    }
    asBuffer() {
        throw new InvalidValueBufferError();
    }
    toContractParameter(_seen = new Set()) {
        return new InteropInterfaceContractParameter();
    }
    toJSONInternal() {
        return JSON.stringify(this.value);
    }
    serializeInternal() {
        throw new UnsupportedStackItemSerdeError();
    }
}

//# sourceMappingURL=ObjectStackItem.js.map
